module.exports = __webpack_public_path__ + "static/waukeen-DND3_FnP-5c2f983ccce13a588e6afd6b3496b680.jpg";